export default {
  hero: {
    title: 'Sazinieties ar Mums',
    subtitle: 'Mēs vienmēr esam gatavi uzklausīt un atbalstīt jūs',
  },
  info: {
    title: 'Kontaktinformācija',
    description: 'Sazinieties ar mums caur zemāk norādītajiem kanāliem vai aizpildiet blakus esošo formu. Mūsu speciālistu komanda atbildēs 24 stundu laikā.',
    address: {
      label: 'Adrese',
      value: 'Krisjana Barona Iela 96/98, Rīga, Latvija',
      line2: 'Mums nav biroja Vjetnamā',
    },
    phone: {
      label: 'Tālrunis',
      value: '+371 2572 6969',
      display: 'Latvija: +371 2572 6969 (Zvans / Whatsapp / Viber)',
    },
    email: {
      label: 'E-pasts',
      value: 'contact@thedaeg.com',
    },
    hours: {
      label: 'Darba Laiks',
      value: 'Pirmdiena - Piektdiena: 9:00 - 18:00',
      saturday: 'Sestdiena: 9:00 - 12:00',
    },
  },
  social: {
    title: 'Sekojiet Mums',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
  },
  form: {
    title: 'Nosūtiet Mums Ziņojumu',
    description: 'Aizpildiet informāciju zemāk, un mēs atbildēsim 24 stundu laikā.',
    labels: {
      fullName: 'Vārds un Uzvārds',
      phone: 'Tālruņa Numurs',
      email: 'E-pasts',
      subject: 'Temats',
      message: 'Saturs',
    },
    placeholders: {
      fullName: 'Ievadiet vārdu un uzvārdu',
      phone: 'Tālruņa numurs',
      email: 'E-pasts',
      subject: 'Par ko jums nepieciešams atbalsts?',
      message: 'Detalizēti aprakstiet savu jautājumu... (maksimums 500 rakstzīmes)',
    },
    required: 'Obligāts',
    submit: 'Nosūtīt Ziņojumu',
    submitting: 'Nosūta...',
    success: 'Ziņojums nosūtīts veiksmīgi! Mēs sazināsimies ar jums drīzumā.',
    error: 'Radās kļūda. Lūdzu, mēģiniet vēlreiz vēlāk.',
    charCount: 'rakstzīmes',
  },
  breadcrumb: {
    home: 'Sākumlapa',
    contact: 'Kontakti',
  },
} as const;
